export const FREE_ROBO_COUNT = 2;
export const BEGINNING_ROBO_COUNT = 2;
export const BASIC_ROBO_COUNT = 6;
export const PREMIUM_ROBO_COUNT = 10;

export const FREE_ACCESS_COUNT = 10;
export const BEGINNING_ACCESS_COUNT = 20;
export const BASIC_WGPT_COUNT = 10;
export const PREMIUM_WGPT_COUNT = 20;
